import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideMenuComponent } from '../../reporting-page/side-menu/side-menu.component';

@Component({
  selector: 're-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.css',
  imports: [SideMenuComponent, RouterOutlet],
})
export class MainLayoutComponent {}
